import React, { useContext, useEffect, useState } from 'react';
import 'antd/dist/antd.min.css';
import { Layout, Select } from 'antd'
import { Outlet } from 'react-router-dom';
import DrawerMenu from '../menu/DrawerMenu';
import SideMenu from '../menu/SideMenu';
import Loader from '../loader/Loader';
import ProfileOptions from '../menu/ProfileOptions';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import SL_Button from '../buttons/Button';
import { RollbackOutlined } from '@ant-design/icons';
import api from '../../services/api';
import { displayMessage } from '../../services/helper';
import { SL_CountrySelector } from '../selects/SL_CountrySelector';

const { Header, Content } = Layout;
const { Option } = Select;

const InternalLayout = (props) => {

  const {
    mobile_mode,
    user, setUser,
    setShowLoading,
    enums, setEnums
  } = useContext(GeneralContext)

  const officeHourStart = 9
  const officeHourEnd = 21

  useEffect(() => {
    if (!enums) {
      setShowLoading(true)
      
      api.auth.getEnums().then(
        rs => setEnums(rs.data)
      ).finally(
        () => setShowLoading(false)
      )

      return
    } else {
      user.user_type == enums.EUserTypes.MONITOR.code && setStatusSelectValue(user.monitor_status)
    }
  }, [enums])

  useEffect(() => {
    setStatusSelectValue(user?.monitor_status)
  }, [user])

  const handelChangeStatus = async (value) => {
    try {
      let payload = { id: user.id, code: value }
      const { data: updatedUser } = await api.user.changeStatus(payload)
      setUser(updatedUser)
      setStatusSelectValue(value)

    }
    catch (error) {
      setStatusSelectValue(enums?.EMonitorStatus?.UNAVAILABLE?.code)
    }
  }
  const [statusSelectValue, setStatusSelectValue] = useState(0)

  const statusOptions = [
    <Option key={enums?.EMonitorStatus?.AVAILABLE?.code}
      value={enums?.EMonitorStatus?.AVAILABLE?.code}
    >
      <div style={{
        fontWeight: 'bold',
        paddingLeft: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

      }}
      >
        {enums?.EMonitorStatus?.AVAILABLE.description}
        <div style={{ width: 10, height: 10, borderRadius: 5, marginLeft: 5, background: enums?.EMonitorStatus?.AVAILABLE?.color, }} />
      </div>
    </Option>,
    <Option key={enums?.EMonitorStatus?.ONBREACK?.code}
      value={enums?.EMonitorStatus?.ONBREACK?.code}
    >
      <div style={{
        fontWeight: 'bold',
        paddingLeft: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      >
        {enums?.EMonitorStatus?.ONBREACK.description}
        <div style={{ width: 10, height: 10, borderRadius: 5, marginLeft: 5, background: enums?.EMonitorStatus?.ONBREACK?.color, }} />
      </div>
    </Option>,
    <Option key={enums?.EMonitorStatus?.UNAVAILABLE?.code}
      value={enums?.EMonitorStatus?.UNAVAILABLE?.code}
    >
      <div style={{
        fontWeight: 'bold',
        paddingLeft: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      >
        {enums?.EMonitorStatus?.UNAVAILABLE.description}
        <div style={{ width: 10, height: 10, borderRadius: 5, marginLeft: 5, background: enums?.EMonitorStatus?.UNAVAILABLE?.color, }} />

      </div>
    </Option>,
  ]

  return (
    <Layout style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'row' }}>

      <Loader />

      {mobile_mode ? <DrawerMenu /> : <SideMenu />}

      <Layout className="site-layout" style={{ background: "white", display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <Header style={{ display: 'flex', height: mobile_mode ? 95 : "", background: 'white', padding: 0, borderBottom: '2px solid #1b3663', boxShadow: '0px -15px 39px #1b3663' }}>

          {/* <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', paddingBottom: mobile_mode ? 10 : '' }}> */}
          <div style={{ display: 'flex', flex: 1, alignItems: 'center', flexDirection: 'row', paddingBottom: mobile_mode ? 10 : '' }}>
            {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: mobile_mode ? 'flex-end' : 'flex-start', marginRight: mobile_mode ? 10 : '', height: mobile_mode ? '100%' : '', paddingBottom: mobile_mode ? 2 : '' }}>
              <SL_Button
                onClick={() => { window.location.href = '/monitory-room' }}
                icon={<RollbackOutlined />}
                style={{ marginTop: mobile_mode ? 15 : 0, marginLeft: mobile_mode ? 21   : 10, background: 'orange', color: `white`, fontWeight: 'bold' }}>
                {mobile_mode ? '' : displayMessage('MONITORY_ROOM')}
              </SL_Button>
            </div> */}

            <div style={{  display: 'flex', flexDirection: mobile_mode ? 'column-reverse' : 'row', justifyContent: mobile_mode ? 'space-between' : 'center', alignItems: mobile_mode ? 'flex-end' : 'center', width: '100%', padding: mobile_mode ? '0 10px' : '0 20px' }}>
              {user?.user_type_formatted?.id == enums?.EUserTypes?.MONITOR?.code ?
                <div style={
                  {
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginLeft: mobile_mode ? 0 : 20,
                    marginTop: mobile_mode ? 8 : 0,
                    maxHeight: "32px",
                    borderRadius: 5,
                    paddingLeft: 5,
                  }
                }>
                  {
                    <Select
                      style={{ width: 150, marginRight: 15 }}
                      size="middle"
                      onChange={value => handelChangeStatus(value)}
                      value={statusSelectValue}
                      showArrow={false}
                    >
                      {statusOptions}
                    </Select>
                  }
                </div>
                : null
              }
              <ProfileOptions />
            </div>

            <div className='flex p-2 justify-end flex-1'>
                <SL_CountrySelector/>
            </div>
          </div>
        </Header>

        <Content
          className="site-layout-background"
          style={{
            marginTop: 5,
            padding: mobile_mode? 0 : 16,
            flex: 1,
            overflow: 'auto'
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}

export default InternalLayout;
